import BanIcon from "../../icons/ban.svg?react";
import AnchorIcon from "../../icons/anchor.svg?react";
import BatteryBoltIcon from "../../icons/battery-bolt.svg?react";
import BandageIcon from "../../icons/bandage.svg?react";
import BedIcon from "../../icons/bed.svg?react";
import BellIcon from "../../icons/bell-alt.svg?react";
import BoltIcon from "../../icons/bolt.svg?react";
import BookIcon from "../../icons/book.svg?react";
import BoxArchiveIcon from "../../icons/box-archive.svg?react";
import BugIcon from "../../icons/bug.svg?react";
import BuildingIcon from "../../icons/building.svg?react";
import BuildingsIcon from "../../icons/buildings.svg?react";
import CalendarAltIcon from "../../icons/calendar-alt.svg?react";
import CameraIcon from "../../icons/camera-new.svg?react";
import CamCoderIcon from "../../icons/camcorder.svg?react";
import CarIcon from "../../icons/car.svg?react";
import CashRegisterIcon from "../../icons/cash-register.svg?react";
import CatIcon from "../../icons/cat.svg?react";
import CctvIcon from "../../icons/cctv.svg?react";
import CertificateCheckIcon from "../../icons/certificate-check.svg?react";
import CheckIcon from "../../icons/check.svg?react";
import CircleExclamationIcon from "../../icons/circle-exclamation.svg?react";
import CircleParkingIcon from "../../icons/circle-parking.svg?react";
import CircleDollarIcon from "../../icons/circle-dollar.svg?react";
import CircleUserIcon from "../../icons/circle-user-new.svg?react";
import CircuitIcon from "../../icons/circuit.svg?react";
import ClipBoardListIcon from "../../icons/clipboard-list.svg?react";
import ClipBoardPlusIcon from "../../icons/clipboard-plus.svg?react";
import ClocheIcon from "../../icons/cloche.svg?react";
import ClockIcon from "../../icons/clock.svg?react";
import CloudIcon from "../../icons/cloud-big.svg?react";
import CloudBoltIcon from "../../icons/cloud-bolt.svg?react";
import CloudRainbowIcon from "../../icons/cloud-rainbow.svg?react";
import ContainerStorageIcon from "../../icons/container-storage.svg?react";
import CodeForkIcon from "../../icons/code-fork.svg?react";
import CompassIcon from "../../icons/compass.svg?react";
import DazzlingStarIcon from "../../icons/dazzling-star.svg?react";
import DesktopComputerIcon from "../../icons/desktop-computer.svg?react";
import DroneIcon from "../../icons/drone.svg?react";
import EngineWarningIcon from "../../icons/engine-warning.svg?react";
import FolderIcon from "../../icons/folder-close.svg?react";
import FilesIcon from "../../icons/files.svg?react";
import FileIcon from "../../icons/file.svg?react";
import FileAltIcon from "../../icons/file-alt.svg?react";
import ForkKnifeIcon from "../../icons/fork-knife.svg?react";
import FingerprintIcon from "../../icons/fingerprint.svg?react";
import FaceFrownIcon from "../../icons/face-frown.svg?react";
import FaceSmileIcon from "../../icons/face-smile.svg?react";
import FenceIcon from "../../icons/fence.svg?react";
import GamingPadIcon from "../../icons/gaming-pad.svg?react";
import GemAltIcon from "../../icons/gem-alt.svg?react";
import HospitalIcon from "../../icons/hospital.svg?react";
import HospitalsIcon from "../../icons/hospitals.svg?react";
import HotelIcon from "../../icons/hotel.svg?react";
import HouseFloorIcon from "../../icons/house-floor.svg?react";
import HouseMedicalIcon from "../../icons/house-medical.svg?react";
import HourglassHalfIcon from "../../icons/hourglass-half.svg?react";
import HeadphonesIcon from "../../icons/headphones.svg?react";
import HeartIcon from "../../icons/heart.svg?react";
import ImageCircleIcon from "../../icons/image-circle.svg?react";
import KeyboardIcon from "../../icons/keyboard.svg?react";
import KitMedicalIcon from "../../icons/kit-medical.svg?react";
import LockIcon from "../../icons/lock.svg?react";
import LocationCrosshairsIcon from "../../icons/location-crosshairs.svg?react";
import LocationPinIcon from "../../icons/location-pin.svg?react";
import LaptopMedicalIcon from "../../icons/laptop-medical.svg?react";
import LaptopAltIcon from "../../icons/laptop-alt.svg?react";
import MusicNoteIcon from "../../icons/music-note.svg?react";
import MaskFaceIcon from "../../icons/mask-face.svg?react";
import MobileAltIcon from "../../icons/mobile-alt.svg?react";
import ModemIcon from "../../icons/modem.svg?react";
import MonitorAltIcon from "../../icons/monitor-alt.svg?react";
import MoveIcon from "../../icons/move.svg?react";
import MouseAltIcon from "../../icons/mouse-alt.svg?react";
import MonitorHeartRateIcon from "../../icons/monitor-heart-rate.svg?react";
import MoonIcon from "../../icons/moon.svg?react";
import MicrophoneIcon from "../../icons/microphone.svg?react";
import NetworkWiredIcon from "../../icons/network-wired.svg?react";
import PaperclipAltIcon from "../../icons/paperclip-alt.svg?react";
import PhoneOfficeIcon from "../../icons/phone-office.svg?react";
import PrescriptionBottleMedicalIcon from "../../icons/prescription-bottle-medical.svg?react";
import PrinterIcon from "../../icons/printer.svg?react";
import PhoneIcon from "../../icons/phone.svg?react";
import PrescriptionBottleIcon from "../../icons/prescription-bottle.svg?react";
import PartyHornIcon from "../../icons/party-horn.svg?react";
import PlugIcon from "../../icons/plug.svg?react";
import RocketIcon from "../../icons/rocket.svg?react";
import RadiationIcon from "../../icons/radiation.svg?react";
import RularIcon from "../../icons/ruler.svg?react";
import SensorIcon from "../../icons/sensor.svg?react";
import SitemapIcon from "../../icons/sitemap.svg?react";
import SnowAltIcon from "../../icons/snow-alt.svg?react";
import ServerIcon from "../../icons/server.svg?react";
import SignalStreamSlashIcon from "../../icons/signal-stream-slash.svg?react";
import SignalSteamIcon from "../../icons/signal-steam.svg?react";
import SquareMedicalIcon from "../../icons/square-medical.svg?react";
import ShieldCheckIcon from "../../icons/shield-check.svg?react";
import SparklesIcon from "../../icons/sparkles.svg?react";
import SuitcaseMedicalIcon from "../../icons/suitcase-medical.svg?react";
import SpiderIcon from "../../icons/spider.svg?react";
import ShieldIcon from "../../icons/shield.svg?react";
import StaffSnakeIcon from "../../icons/staff-snake.svg?react";
import SkullCrossbonesIcon from "../../icons/skull-crossbones.svg?react";
import SunIcon from "../../icons/sun.svg?react";
import ThumbtackIcon from "../../icons/thumbtack.svg?react";
import ToiletPaperDotsIcon from "../../icons/toilet-paper-dots.svg?react";
import TicketSimpleIcon from "../../icons/ticket-simple.svg?react";
import TemperatureHighIcon from "../../icons/temperature-high.svg?react";
import TvIcon from "../../icons/tv.svg?react";
import TrophyIcon from "../../icons/trophy.svg?react";
import TriangleIcon from "../../icons/triangle.svg?react";
import TowerBroadcastIcon from "../../icons/tower-broadcast.svg?react";
import UsbFlashDriveIcon from "../../icons/usb-flash-drive.svg?react";
import UniversityIcon from "../../icons/university.svg?react";
import VolumeMaxIcon from "../../icons/volume-max.svg?react";
import VolumeXmarkIcon from "../../icons/volume-xmark.svg?react";
import VirusCovid19Icon from "../../icons/virus-covid-19.svg?react";
import WifiExclamationIcon from "../../icons/wifi-exclamation.svg?react";
import WarehouseIcon from "../../icons/warehouse.svg?react";
import WineGlassIcon from "../../icons/wine-glass.svg?react";
import WebcamIcon from "../../icons/webcam.svg?react";
import WifiIcon from "../../icons/wifi.svg?react";
import WavePulseIcon from "../../icons/wave-pulse.svg?react";

export const isDefaultViewNavigationIcon = (iconName?: string | null) => !iconName || iconName === "Default" || iconName === "Ban";

export const iconSet = [
	{
		label: "Default",
		IconComponent: BanIcon,
	},
	{
		label: "Anchor",
		IconComponent: AnchorIcon,
	},
	{
		label: "Battery Bolt",
		IconComponent: BatteryBoltIcon,
	},
	{
		label: "Bandage",
		IconComponent: BandageIcon,
	},
	{
		label: "Bed",
		IconComponent: BedIcon,
	},
	{
		label: "Bell",
		IconComponent: BellIcon,
	},
	{
		label: "Bolt",
		IconComponent: BoltIcon,
	},
	{
		label: "Book",
		IconComponent: BookIcon,
	},
	{
		label: "Box Archive",
		IconComponent: BoxArchiveIcon,
	},
	{
		label: "Bug",
		IconComponent: BugIcon,
	},
	{
		label: "Building",
		IconComponent: BuildingIcon,
	},
	{
		label: "Buildings",
		IconComponent: BuildingsIcon,
	},
	{
		label: "Calendar Alt",
		IconComponent: CalendarAltIcon,
	},
	{
		label: "Camera",
		IconComponent: CameraIcon,
	},
	{
		label: "Camcoder",
		IconComponent: CamCoderIcon,
	},
	{
		label: "Car",
		IconComponent: CarIcon,
	},
	{
		label: "Cash Register",
		IconComponent: CashRegisterIcon,
	},
	{
		label: "Cat",
		IconComponent: CatIcon,
	},
	{
		label: "Cctv",
		IconComponent: CctvIcon,
	},
	{
		label: "Certificate Check",
		IconComponent: CertificateCheckIcon,
	},
	{
		label: "Check",
		IconComponent: CheckIcon,
	},
	{
		label: "Circle Exclamation",
		IconComponent: CircleExclamationIcon,
	},
	{
		label: "Circle Parking",
		IconComponent: CircleParkingIcon,
	},
	{
		label: "Circle Dollar",
		IconComponent: CircleDollarIcon,
	},
	{
		label: "Circle User",
		IconComponent: CircleUserIcon,
	},
	{
		label: "Circuit",
		IconComponent: CircuitIcon,
	},
	{
		label: "Clipboard List",
		IconComponent: ClipBoardListIcon,
	},
	{
		label: "Clipboard Plus",
		IconComponent: ClipBoardPlusIcon,
	},
	{
		label: "Cloche",
		IconComponent: ClocheIcon,
	},
	{
		label: "Cloud",
		IconComponent: CloudIcon,
	},
	{
		label: "Cloud Bolt",
		IconComponent: CloudBoltIcon,
	},
	{
		label: "Cloud Rainbow",
		IconComponent: CloudRainbowIcon,
	},
	{
		label: "Clock",
		IconComponent: ClockIcon,
	},
	{
		label: "Container Storage",
		IconComponent: ContainerStorageIcon,
	},
	{
		label: "Code Fork",
		IconComponent: CodeForkIcon,
	},
	{
		label: "Compass",
		IconComponent: CompassIcon,
	},
	{
		label: "Dazzling Star",
		IconComponent: DazzlingStarIcon,
	},
	{
		label: "Desktop Computer",
		IconComponent: DesktopComputerIcon,
	},
	{
		label: "Drone",
		IconComponent: DroneIcon,
	},
	{
		label: "Engine Warning",
		IconComponent: EngineWarningIcon,
	},
	{
		label: "Folder",
		IconComponent: FolderIcon,
	},
	{
		label: "Files",
		IconComponent: FilesIcon,
	},
	{
		label: "File",
		IconComponent: FileIcon,
	},
	{
		label: "File Alt",
		IconComponent: FileAltIcon,
	},
	{
		label: "Fork Knife",
		IconComponent: ForkKnifeIcon,
	},
	{
		label: "Fingerprint",
		IconComponent: FingerprintIcon,
	},
	{
		label: "Face Frown",
		IconComponent: FaceFrownIcon,
	},
	{
		label: "Face Smile",
		IconComponent: FaceSmileIcon,
	},
	{
		label: "Fence",
		IconComponent: FenceIcon,
	},
	{
		label: "Gaming Pad",
		IconComponent: GamingPadIcon,
	},
	{
		label: "Gem Alt",
		IconComponent: GemAltIcon,
	},
	{
		label: "Hospital",
		IconComponent: HospitalIcon,
	},
	{
		label: "Hospitals",
		IconComponent: HospitalsIcon,
	},
	{
		label: "Hotel",
		IconComponent: HotelIcon,
	},
	{
		label: "House Floor",
		IconComponent: HouseFloorIcon,
	},
	{
		label: "House Medical",
		IconComponent: HouseMedicalIcon,
	},
	{
		label: "Hourglass Half",
		IconComponent: HourglassHalfIcon,
	},
	{
		label: "Headphones",
		IconComponent: HeadphonesIcon,
	},
	{
		label: "Heart",
		IconComponent: HeartIcon,
	},
	{
		label: "Image Circle",
		IconComponent: ImageCircleIcon,
	},
	{
		label: "Keyboard",
		IconComponent: KeyboardIcon,
	},
	{
		label: "Kit Medical",
		IconComponent: KitMedicalIcon,
	},
	{
		label: "Lock",
		IconComponent: LockIcon,
	},
	{
		label: "Location Crosshairs",
		IconComponent: LocationCrosshairsIcon,
	},
	{
		label: "Location Pin",
		IconComponent: LocationPinIcon,
	},
	{
		label: "Laptop Medical",
		IconComponent: LaptopMedicalIcon,
	},
	{
		label: "Laptop Alt",
		IconComponent: LaptopAltIcon,
	},
	{
		label: "Music Note",
		IconComponent: MusicNoteIcon,
	},
	{
		label: "Mask Face",
		IconComponent: MaskFaceIcon,
	},
	{
		label: "Mobile Alt",
		IconComponent: MobileAltIcon,
	},
	{
		label: "Modem",
		IconComponent: ModemIcon,
	},
	{
		label: "Monitor Alt",
		IconComponent: MonitorAltIcon,
	},
	{
		label: "Move",
		IconComponent: MoveIcon,
	},
	{
		label: "Mouse Alt",
		IconComponent: MouseAltIcon,
	},
	{
		label: "Monitor Heart Rate",
		IconComponent: MonitorHeartRateIcon,
	},
	{
		label: "Moon",
		IconComponent: MoonIcon,
	},
	{
		label: "Microphone",
		IconComponent: MicrophoneIcon,
	},
	{
		label: "Network Wired",
		IconComponent: NetworkWiredIcon,
	},
	{
		label: "Paperclip Alt",
		IconComponent: PaperclipAltIcon,
	},
	{
		label: "Phone Office",
		IconComponent: PhoneOfficeIcon,
	},
	{
		label: "Prescription Bottle Medical",
		IconComponent: PrescriptionBottleMedicalIcon,
	},
	{
		label: "Printer",
		IconComponent: PrinterIcon,
	},
	{
		label: "Phone",
		IconComponent: PhoneIcon,
	},
	{
		label: "Prescription Bottle",
		IconComponent: PrescriptionBottleIcon,
	},
	{
		label: "Party Horn",
		IconComponent: PartyHornIcon,
	},
	{
		label: "Plug",
		IconComponent: PlugIcon,
	},
	{
		label: "Rocket",
		IconComponent: RocketIcon,
	},
	{
		label: "Radiation",
		IconComponent: RadiationIcon,
	},
	{
		label: "Rular",
		IconComponent: RularIcon,
	},
	{
		label: "Sensor",
		IconComponent: SensorIcon,
	},
	{
		label: "Sitemap",
		IconComponent: SitemapIcon,
	},
	{
		label: "Snow Alt",
		IconComponent: SnowAltIcon,
	},
	{
		label: "Server",
		IconComponent: ServerIcon,
	},
	{
		label: "Signal Stream Slash",
		IconComponent: SignalStreamSlashIcon,
	},
	{
		label: "Signal Steam",
		IconComponent: SignalSteamIcon,
	},
	{
		label: "Square Medical",
		IconComponent: SquareMedicalIcon,
	},
	{
		label: "Shield Check",
		IconComponent: ShieldCheckIcon,
	},
	{
		label: "Sparkles",
		IconComponent: SparklesIcon,
	},
	{
		label: "Suitcase Medical",
		IconComponent: SuitcaseMedicalIcon,
	},
	{
		label: "Spider",
		IconComponent: SpiderIcon,
	},
	{
		label: "Shield",
		IconComponent: ShieldIcon,
	},
	{
		label: "Staff Snake",
		IconComponent: StaffSnakeIcon,
	},

	{
		label: "Skull Crossbones",
		IconComponent: SkullCrossbonesIcon,
	},
	{
		label: "Sun",
		IconComponent: SunIcon,
	},
	{
		label: "Thumbtack",
		IconComponent: ThumbtackIcon,
	},
	{
		label: "Toilet Paper Dots",
		IconComponent: ToiletPaperDotsIcon,
	},
	{
		label: "Ticket Simple",
		IconComponent: TicketSimpleIcon,
	},
	{
		label: "Temperature High",
		IconComponent: TemperatureHighIcon,
	},
	{
		label: "Tv",
		IconComponent: TvIcon,
	},
	{
		label: "Trophy",
		IconComponent: TrophyIcon,
	},
	{
		label: "Triangle",
		IconComponent: TriangleIcon,
	},
	{
		label: "Tower Broadcast",
		IconComponent: TowerBroadcastIcon,
	},
	{
		label: "USB Flash Drive",
		IconComponent: UsbFlashDriveIcon,
	},
	{
		label: "University",
		IconComponent: UniversityIcon,
	},
	{
		label: "Volume Max",
		IconComponent: VolumeMaxIcon,
	},
	{
		label: "Volume Xmark",
		IconComponent: VolumeXmarkIcon,
	},
	{
		label: "Virus Covid19",
		IconComponent: VirusCovid19Icon,
	},
	{
		label: "Wifi Exclamation",
		IconComponent: WifiExclamationIcon,
	},
	{
		label: "Warehouse",
		IconComponent: WarehouseIcon,
	},
	{
		label: "Wine Glass",
		IconComponent: WineGlassIcon,
	},
	{
		label: "Webcam",
		IconComponent: WebcamIcon,
	},
	{
		label: "Wifi",
		IconComponent: WifiIcon,
	},
	{
		label: "Wave Pulse",
		IconComponent: WavePulseIcon,
	},
];
